export default __webpack_public_path__ + "images/face.png";